declare const require: any;
const shepherdJs = require('shepherd.js');

// Export the Shepherd object directly
export const Shepherd = shepherdJs.default || shepherdJs;
